import React from 'react'
import styles from './MESATabular.js'

const MESATabular = () => {
    return (
        <div>MESATabular</div>
    )
}

export default MESATabular